import React from "react";
import { Card } from "./styles";

import ReportsTumorBoardView from "../../views/ReportsTumorBoard/index.jsx";

export default function HomeUnimed() {
  return (
    <div>
      <Card>
        <ReportsTumorBoardView />
      </Card>
    </div>
  );
}
